module.exports = __webpack_public_path__ + "resources/img/img_security_shellcop_en_m.bc22ab2a4a634250428d9ab656d29f95.png";